import * as moment from 'moment';

export class Interval {

  constructor(
    public from: string,
    public to: string,
  ) { 
  }


  getDurationInSeconds() {
    return moment( this.to ).diff( moment( this.from ), 'seconds')
  }

  getDurationInMinutes() {
    return moment( this.to ).diff( moment( this.from ), 'minutes')
  }

  moveToNewFrom( newFrom ) {

    let oldDuration = this.getDurationInSeconds();

    this.from = newFrom;
    this.to = moment( this.from ).add( oldDuration, 'seconds' ).format();

  }

  changeFrom( numberOfMinutes, direction = '+', fixedDuration = true ) {

    let oldDuration = this.getDurationInSeconds();

    if ( '+' === direction ) {

      if ( this.getDurationInMinutes < numberOfMinutes ) {
        return false;
      }

      this.from = moment( this.from ).add( numberOfMinutes, 'minutes' ).format();

      if ( fixedDuration ) {
        this.to = moment( this.from ).add( oldDuration, 'seconds' ).format();
      }


    } else {

      this.from = moment( this.from ).subtract( numberOfMinutes, 'minutes' ).format();

      if ( fixedDuration ) {
        this.to = moment( this.from ).add( oldDuration, 'seconds' ).format();
      }

    }
   
  }


  changeTo( numberOfMinutes, direction = '+' ) {

    if ( '+' === direction ) {

      this.to = moment( this.to ).add( numberOfMinutes, 'minutes' ).format();

    } else {

      if ( this.getDurationInMinutes < numberOfMinutes ) {
        return false;
      }

      this.to = moment( this.to ).subtract( numberOfMinutes, 'minutes' ).format();

    }
   
  }

  setDuration( numberOfMinutes ) {
    this.to = moment( this.from ).add( numberOfMinutes, 'minutes' ).format();
  }

}